import { Button, Divider, Grid, makeStyles, Paper } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useTranslation } from "react-i18next";
import ConditionalSearch from "./ConditionalSearch";
import ErrorIcon from '@material-ui/icons/Error';
import { useEffect, useState } from "react";
import CreateDetails from "./CreateDetails";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getBranchById, getUserPreference } from "../../utilities/common";
import { createTask, queryTaskDetail } from "../../actions/orderExchangeActions";
import BatchDetails from "./BatchDetails";
import { showAlertSnackbar } from "../../reducers/uiSlice";
import ScanProcess from "./ScanProcess";

const useStyles = makeStyles((theme) => ({
    infoSection: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(2),
        display: 'flex',
        alignItems: "center",
        justifyContent: 'space-between'
    },
    summarySection: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        display: 'flex',
        alignItems: "center"
    },
    groupSection: {
        marginRight: theme.spacing(4),
        display: 'flex',
        alignItems: 'center'
    },
    dataGridSection: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(1)
    }
}))

export default function OrderForwardToolManagement(props) {
    const {t} = useTranslation('orderForwardTool');
    const classes = useStyles();
    const dispatch = useDispatch();

    const userpref = getUserPreference();

    const orderListOri = useSelector(state => state.orderExchangeReducer.queryToBeForwardOrders);
    const batchListOri = useSelector(state => state.orderExchangeReducer.queryTaskList);

    const statuses = {
        '0': {
            text: t('pending')
        },
        '1': {
            text: t('order_placed')
        },
        '2': {
            text: t('order_printed')
        },
        '3': {
            text: t('failed_to_forward')
        }
    }

    const columnsOrders = [
        {field: 'id', hide: true},
        {
            field: 'tno', 
            headerName: t('uni_tracking_no'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'reference', 
            headerName: t('uni_batch_number'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'warehouse', 
            headerName: t('warehouse'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => getBranchById(params.value).name,
            sortable: false
        },
        {
            field: 'add_time', 
            headerName: t('order_received_time'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => params.value ? moment.unix(Number(params.value)).format("MMM DD, YYYY - HH:mm:ss") : '',
            sortable: false
        },
        {
            field: 'transship_status', 
            headerName: t('status'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <span>{statuses[params.value + ''].text}</span>
                    {
                        params.row.transship_status + '' === '2' &&
                        <span><ErrorIcon style={{color: 'red', marginLeft: 5}}/></span>
                    }
                </div>
            ),
            sortable: false
        }
    ]

    const columnsBatches = [
        {field: 'id', hide: true},
        {
            field: 'task_name', 
            headerName: t('forward_batch_id'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'total_count', 
            headerName: t('number_of_parcels'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        // {
        //     field: 'warehouse', 
        //     headerName: t('warehouse'), 
        //     flex: 1,
        //     headerAlign: 'center',
        //     align: 'center',
        //     valueFormatter: (params) => getBranchById(params.value).name,
        //     sortable: false
        // },
        {
            field: 'create_time', 
            headerName: t('create_time'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => params.value ? moment.unix(Number(params.value)).format("MMM DD, YYYY - HH:mm:ss") : '',
            sortable: false
        },
        {
            field: 'creator', 
            headerName: t('created_by'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'status', 
            headerName: t('status'), 
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            renderCell: (params) => (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <span>{statuses[params.value + ''].text}</span>
                    {
                        params.row.transship_status + '' === '3' &&
                        <span><ErrorIcon style={{color: 'red', marginLeft: 5}}/></span>
                    }
                </div>
            )
        }
    ]

    const SUMMARY_LIST = {
        pending: 0,
        orderPlaced: 0,
        failedToForward: 0
    };

    const [createOpen, setCreateOpen] = useState(false);
    const [task, setTask] = useState({
        taskName: '',
        taskId: ''
    });
    const [selected, setSelected] = useState([]);
    const [summary, setSummary] = useState(SUMMARY_LIST);
    const [batchOpen, setBatchOpen] = useState(false);
    const [taskName, setTaskName] = useState('');
    const [orderList, setOrderList] = useState([]);
    const [batchList, setBatchList] = useState([]);

    
    const createRows = () => {
        if(props.type === 'orders') {
            return orderList.map((row) => {
                const {order_id, ...rest} = row
                return {id: order_id, ...rest}
            })
        } else {
            return batchList.map((row) => {
                const {...rest} = row
                return {...rest}
            })
        }
    }

    const handleSummary = (order) => {
        if(order.transship_status + '' === '0') {
            setSummary((prev) => ({
                ...prev,
                ['pending']: summary.pending + 1
            }))
        } else if(order.transship_status + '' === '1') {
            setSummary((prev) => ({
                ...prev,
                ['orderPlaced']: summary.orderPlaced + 1
            }))
        } else if(order.transship_status + '' === '2') {
            setSummary((prev) => ({
                ...prev,
                ['failedToForward']: summary.failedToForward + 1
            }))
        }
    } 

    const handleCreateClose = () => {
        setCreateOpen(false);
        setOrderList([]);
    }

    const handleBatchClose = () => {
        setBatchOpen(false);
        setBatchList([]);
    }

    const handleCreate = () => {
        dispatch(createTask({
            orders:orderList,
            warehouse: userpref.userCity
        }))
        .then((res) => {
            setTask({
                taskName: res.task_name,
                taskId: res.id
            })
            setCreateOpen(true);
        })
        .catch(() => {
            showAlertSnackbar({message: t('create_task_fail'), type: 'error'})
        })
    }

    const initSummary = () => {
        setSummary(SUMMARY_LIST);
    }


    useEffect(() => {
        setTask({
            taskName: '',
            taskId: ''
        });
    }, [])

    useEffect(() => {
        setOrderList(orderListOri);
    }, [orderListOri])

    useEffect(() => {
        setBatchList(batchListOri);
    }, [batchListOri])

    useEffect(() => {
        orderList.forEach(order => {
            handleSummary(order);
        });
    }, [orderList])


    return (
        <Paper>
            {
                props.type !== 'scan' &&
                <>
                    <ConditionalSearch type={props.type} initSummary={initSummary} />
                    <Divider></Divider>
                </>
            }
            {
                props.type === 'orders' &&
                <div className={classes.infoSection}>
                    <div className={classes.summarySection}>
                        <div className={classes.groupSection}>
                            <span style={{marginRight: 5}}>{t('pending')}: </span>
                            <span>{summary.pending}</span>
                        </div>
                        <div className={classes.groupSection}>
                            <span style={{marginRight: 5}}>{t('order_placed')}: </span>
                            <span>{summary.orderPlaced}</span>
                        </div>
                        <div className={classes.groupSection}>
                            <ErrorIcon style={{color: 'red', marginRight: 5}}/>
                            <span style={{marginRight: 5}}>{t('failed_to_forward')}: </span>
                            <span style={{color: 'red'}}>{summary.failedToForward}</span>
                        </div>
                    </div>
                    <Button
                        variant="outlined"
                        color='primary'
                        onClick={handleCreate}
                        id='orderforwardtool-createforwardingbatch-button'
                        disabled={!selected?.length > 0}
                    >
                        {t('create_forwarding_batch')}
                    </Button>
                </div>
            }
            {
                props.type !== 'scan' &&
                <div className={classes.dataGridSection}>
                    <DataGrid
                            style={{ height: '70vh', marginTop: 20 }}
                            alignItems="center"
                            rows={createRows()}
                            columns={props.type === 'orders' ? columnsOrders : columnsBatches}
                            pageSize={20}
                            onSelectionModelChange={(newSelection) => {
                                setSelected(newSelection.map((orderId) => {
                                    return orderList.find(order => order.order_id === orderId)
                                }))
                            }}
                            onRowClick={(selectedRow) => {
                                if (props.type !== 'orders') {
                                    dispatch(queryTaskDetail({ task_id: selectedRow.id }))
                                        .then(() => {
                                            setTaskName(selectedRow.row.task_name)
                                            setBatchOpen(true);
                                        })
                                        .catch(() => {
                                            showAlertSnackbar({ message: t('fetch_batch_detail_fail'), type: 'error' })
                                        })
                                }
                            }}
                            disableSelectionOnClick
                            checkboxSelection={props.type === 'orders'}
                        />
                    </div>
            }
            {
                props.type === 'scan' &&
                <ScanProcess />
            }
            <CreateDetails
                open={createOpen}
                handleClose={handleCreateClose}
                task={task}
                orderList={selected}
                summary={summary}
                statuses={statuses}
            />
            <BatchDetails 
                open={batchOpen}
                handleClose={handleBatchClose}
                taskName={taskName}
                statuses={statuses}
            />
        </Paper>
    );
}